import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 1000 500",
  "content": "<symbol viewBox=\"0 0 1000 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left\">\n<path d=\"M950 268.527C655.446 270.009 356.552 323.376 66.3388 272.975C-3.89925 260.776 170.995 170.37 237.538 144.793C275.476 130.211 186.824 208.496 158.43 237.576C141.916 254.489 123.222 269.443 103.342 282.23C97.7693 285.814 77.9394 282.43 83.7543 285.606C133.887 312.98 187.705 332.987 239.68 356.678\" stroke=\"currentColor\" stroke-width=\"6.18412\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol